/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SubscriptionOverview_subscription = {
    readonly id: string;
    readonly createdAt: string;
    readonly service: {
        readonly name: string;
        readonly imageURL: string;
    };
    readonly usage: {
        readonly intervals: ReadonlyArray<{
            readonly startDate: string;
            readonly endDate: string;
            readonly totalCosts: ReadonlyArray<{
                readonly value: number;
                readonly currency: string;
            }>;
        }>;
    } | null;
    readonly " $refType": "SubscriptionOverview_subscription";
};
export type SubscriptionOverview_subscription$data = SubscriptionOverview_subscription;
export type SubscriptionOverview_subscription$key = {
    readonly " $data"?: SubscriptionOverview_subscription$data;
    readonly " $fragmentRefs": FragmentRefs<"SubscriptionOverview_subscription">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubscriptionOverview_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Service",
      "kind": "LinkedField",
      "name": "service",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageURL",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "before",
          "variableName": "before"
        },
        {
          "kind": "Literal",
          "name": "intervalSeconds",
          "value": 3600
        }
      ],
      "concreteType": "SubscriptionUsage",
      "kind": "LinkedField",
      "name": "usage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UsageInterval",
          "kind": "LinkedField",
          "name": "intervals",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Amount",
              "kind": "LinkedField",
              "name": "totalCosts",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currency",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Subscription",
  "abstractKey": null
};
(node as any).hash = 'df72b5f3a653111d1381a184eff361a1';
export default node;
